import React, { FC, HTMLProps } from 'react';
import {
  Container,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { Check, Telegram, YouTube } from '@mui/icons-material';
import ResponsiveAppBar from '../layout/ResponsiveAppBar';
import TopMenu from '../layout/TopMenu';
import Footer from '../layout/Footer';
import useAgentSystemDocuments from '../hooks/useAgentSystemDocuments';

const RequirementsListItem: FC<HTMLProps<HTMLDivElement>> = ({ children }) => (
  <ListItem disablePadding>
    <ListItemIcon sx={{ minWidth: 28 }}>
      <Check fontSize="small" />
    </ListItemIcon>
    <ListItemText>{children}</ListItemText>
  </ListItem>
);

const InfoPage = () => {
  const { getByType } = useAgentSystemDocuments();
  const commonConditionsSD = getByType('AGENT_COMMON_CONDITIONS');

  return (
    <>
      <ResponsiveAppBar />
      <TopMenu />
      <Container maxWidth="xl">
        <h2>Агентский договор</h2>
        <Link target="_blank" href={commonConditionsSD?.viewUrl}>
          {commonConditionsSD?.name}
        </Link>
        <h2>Презентация для заёмщиков</h2>
        <Link
          target="_blank"
          href="documents/Презентация_2023-июнь%20(Заёмщики).pdf"
        >
          Презентация_2023-июнь (Заёмщики)
        </Link>
        <h2>
          Минимальные требования к заёмщику для получения займа на нашей
          платформе
        </h2>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={6}>
            <span style={{ fontStyle: 'italic' }}>Беззалоговый заём</span>
            <List>
              <RequirementsListItem>
                Срок существования компании: от 12 месяцев
              </RequirementsListItem>
              <RequirementsListItem>Выручка: от 20 млн. ₽</RequirementsListItem>
              <RequirementsListItem>Отсутствие убытков</RequirementsListItem>
            </List>
          </Grid>
          <Grid item xs={12} sm={6}>
            <span style={{ fontStyle: 'italic' }}>
              Возможность предоставить залог со стороны заемщика для повышения
              одобрения
            </span>
          </Grid>
        </Grid>
        <h2>Тарифы</h2>
        <div>
          Доход за 1 заёмщика от 32 000 ₽ Мы выплачиваем 2% от суммы займа
          первого привлечённого вами бизнеса, и 1% от последующих займов этого
          бизнеса, средняя сумма займа на платформе — 1,6 млн ₽
        </div>
        <h2>Ответы на частозадаваемые вопросы</h2>
        <Link target="_blank" href="https://www.moneyfriends.ru/faq.html">
          FAQ
        </Link>
        <h2>Мы в социальных сетях</h2>
        <div>
          <IconButton
            href="https://t.me/moneyfriends_ru"
            target="_blank"
            sx={{
              mr: 1,
              mb: 2,
            }}
          >
            <Telegram
              style={{
                fill: '#2AABEE',
                fontSize: '32px',
              }}
            />
          </IconButton>
          <IconButton
            href="https://www.youtube.com/channel/UCv60HxsJWjp5yTKYdBCYupQ"
            target="_blank"
            sx={{
              mr: 1,
              mb: 2,
            }}
          >
            <YouTube
              style={{
                fill: '#FF0000',
                fontSize: '32px',
              }}
            />
          </IconButton>
          <IconButton
            href="https://vk.com/moneyfriends_ru"
            target="_blank"
            sx={{
              mr: 1,
              mb: 2,
            }}
          >
            <img src="img/vk.svg" alt="vk" style={{ width: '32px' }} />
          </IconButton>
        </div>
        <div>
          <Link
            target="_blank"
            href="https://www.moneyfriends.ru/news/about.html"
          >
            СМИ О НАС
          </Link>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default InfoPage;
